module.exports = __webpack_public_path__ + "static/media/ehealth_survey_banner_mobile.fb8747ff.png";